import { useFormSchema } from "src/api/hooks/useFormSchema";
export const URLWidget = (props: any) => {
  const { value, onChange, label, required, id, uiSchema } = props;
  const { data: schema } = useFormSchema();
  const primaryColor = schema?.theme?.colors?.primary;
  const secondaryColor = schema?.theme?.colors?.secondary;

  return (
    <div className={`url-container container`}>
      <input
        type="url"
        className={`input-url`}
        value={value ?? ""}
        onChange={(e) => onChange(e.target.value)}
        required={required}
        placeholder="https://"
      />
    </div>
  );
};
